import { render, staticRenderFns } from "./FlashMessage.vue?vue&type=template&id=6fc79b0a&"
import script from "./FlashMessage.vue?vue&type=script&lang=js&"
export * from "./FlashMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc79b0a')) {
      api.createRecord('6fc79b0a', component.options)
    } else {
      api.reload('6fc79b0a', component.options)
    }
    module.hot.accept("./FlashMessage.vue?vue&type=template&id=6fc79b0a&", function () {
      api.rerender('6fc79b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/FlashMessage.vue"
export default component.exports